import { motion } from "framer-motion";
import { sellerHeader } from "../animation/RoutesAnimations";
import { useState } from "react";
import UserStepper from "../pages/user-stepper/UserStepper";
import HeaderLanding from "../components/header/HeaderLanding";
import StepsTitle from "../components/Stepper/StepsTitle";
import { Helmet } from "react-helmet";

const UserLayout = ({ enteredUser, setEnteredUser, newPageRef2 }: any) => {
  const [formNo, setFormNo] = useState<number>(1);
  const [isChildVisible, setIsChildVisible] = useState(false);

  const toggleChildVisibility = () => {
    setIsChildVisible(!isChildVisible);
  };

  return (
    <>
      <motion.div
        variants={sellerHeader}
        initial="initial"
        animate="final"
        className={` ${formNo === 5 ? "" : "h-screen"} 
         overflow-x-hidden overflow-y-auto
        `}
      >
        <Helmet>
          <title>ثبت نام وامسی</title>
          <meta name="description" content="ثبت نام وامسی" />
          <link rel="canonical" href="https://vam30.com" />
        </Helmet>
        <button
          onClick={toggleChildVisibility}
          data-collapse-toggle="mobile-menu-2"
          type="button"
          className=" items-center p-2 ml-1 text-sm text-gray-500 rounded-lg hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
          aria-controls="mobile-menu-2"
          aria-expanded={isChildVisible ? "true" : "false"}
        >
          <img src="/icons/bars-outline.svg" alt="toggle button" />
        </button>
        <div className="fixed z-[999999999999] bg-white">
          <StepsTitle
            isChildVisible={isChildVisible}
            toggleChildVisibility={toggleChildVisibility}
            formNo={formNo}
          />
        </div>
        <div className="md:block mb-12 sticky top-0 z-50 bg-white">
          <HeaderLanding
            enteredUser={enteredUser}
            setEnteredUser={setEnteredUser}
            newPageRef2={newPageRef2}
          />
        </div>
        <UserStepper
          formNo={formNo}
          setFormNo={setFormNo}
          enteredUser={enteredUser}
          setEnteredUser={setEnteredUser}
        />
      </motion.div>
    </>
  );
};

export default UserLayout;
